<template>
  <div class="container-pay">
    <img
      src="https://api.belladasemana.com.br/storage/br/assine-boleto.png"
      alt="Boleto"
      width="102"
      height="32"
    />
    <div class="row my-3 justify-content-center">
      <div class="col-10">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            name="cpf"
            :placeholder="translate.cpfCreditCards"
            v-maska
            data-maska="###.###.###-##"
            v-model="cpf"
          />
        </div>
      </div>
      <div class="col-10">
        <span class="legend mt-3" v-html="translate.legendFormBoleto"></span>
      </div>
      <div class="text-center mt-3" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else class="col-12 mt-3 d-flex justify-content-center">
        <button class="d-w-btn" type="submit" @click="salvarForm(3)">Concluir Compra</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { mapState, mapActions } from 'pinia'
  import { defineComponent } from 'vue'
  import { localeStore } from 'stores/locale'
  import tradutor from 'tradutors/assine'
  import { userStore } from 'stores/user'
  import { jwtStore } from 'stores/jwt'
  import { event } from 'vue-gtag'
  import api from '../../api'
  import { planStore } from '../../stores/plans'

  export default defineComponent({
    name: 'FormPaymentBoleto',
    emits: ['showBoleto', 'showModalMessages'],
    computed: {
      ...mapState(localeStore, ['locale']),
      ...mapState(userStore, ['isLoggedIn']),
      ...mapState(planStore, ['coupon', 'voucher', 'plans']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return tradutor.portugues
        } else {
          return tradutor.ingles
        }
      }
    },
    data() {
      return {
        cpf: '',
        url: '',
        form: null,
        indexValue: '0,00',
        loading: false
      }
    },
    mounted() {
      let plans = document.getElementsByName('flexRadioPlans')

      plans.forEach((e, index) => {
        if (e.checked) {
          this.eventGTM(index)
        }
      })
    },
    methods: {
      ...mapActions(userStore, ['setUser']),
      ...mapActions(jwtStore, ['setJwt']),
      checkForm(formCheck: object) {
        if (!this.isLoggedIn) {
          if (!formCheck.firstName) {
            this.error('Nome é obrigatório!')
            return false
          }
          if (!formCheck.lastName) {
            this.error('Sobrenome é obrigatório!')
            return false
          }
          if (!formCheck.email) {
            this.error('Email é obrigatório!')
            return false
          }
          if (!formCheck.emailAgain) {
            this.error('Confirmação de email é obrigatório!')
            return false
          }
          if (!formCheck.country) {
            this.error('País é obrigatório!')
            return false
          }
          if (!formCheck.password) {
            this.error('senha é obrigatório!')
            return false
          }
          if (!formCheck.passwordAgain) {
            this.error('Confirmação de senha é obrigatório!')
            return false
          }
          if (!formCheck.acept) {
            this.error('Termos de uso é obrigatório!')
            return false
          }
        }

        if (!formCheck.cpf && this.locale == 'pt-br') {
          this.error('Cpf é obrigatório!')
          return false
        }

        return true
      },
      error(value) {
        this.$emit('showModalMessages', {
          message: { show: true, title: 'Erro', textButton: 'Fechar', textBoby: value }
        })
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'erro',
          erro: {
            tipo: value
          }
        })
      },
      eventGTM(index: number) {
        let value = '0,00'
        if (this.plans[index])
          if (this.plans[index].discount > 0 && this.plans[index].discount_value)
            value = this.plans[index].discount_value
          else value = this.plans[index].value

        this.indexValue = value

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'add_payment_info',
          payment: {
            acionador: this.$route.query.acionador ?? 'link direto',
            tipo: 'Assinatura',
            valor: value,
            currency: this.locale === 'pt-br' ? 'BRL' : 'USD',
            forma: 'Boleto'
          }
        })
      },
      eventGTMPurchase(transaction_id) {
        let plans = document.getElementsByName('flexRadioPlans')
        let value = '0,00'
        plans.forEach((e: any, index) => {
          if (e.checked) {
            if (this.plans[index])
              if (this.plans[index].discount > 0 && this.plans[index].discount_value)
                value = this.plans[index].discount_value
              else value = this.plans[index].value

            this.indexValue = value
          }
        })
        
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'purchase',
          purchase: {
            acionador: this.$route.query.acionador ?? 'link direto',
            tipo: 'Assinatura',
            valor: this.indexValue,
            transaction_id,
            forma: 'Boleto'
          }
        })
      },
      salvarForm(method: number) {
        this.loading = true
        event('checkout2', { method: 'Boleto' })
        if (!this.isLoggedIn)
          this.form = {
            firstName: document.getElementById('firstName').value,
            lastName: document.getElementById('lastName').value,
            email: document.getElementById('email').value,
            emailAgain: document.getElementById('emailAgain').value,
            anotherEmail: document.getElementById('anotherEmail').value,
            country: document.getElementById('country').value,
            password: document.getElementById('password').value,
            passwordAgain: document.getElementById('passwordAgain').value,
            acept: document.getElementById('acept').checked,
            cpf: this.cpf,
            locale: this.locale,
            method
          }
        else
          this.form = {
            cpf: this.cpf,
            locale: this.locale,
            method
          }

        let plans = document.getElementsByName('flexRadioPlans')

        plans.forEach((e) => {
          if (e.checked) {
            this.form.plan = Number(e.id.replace('flexRadioPlans', ''))
          }
        })

        if (this.checkForm(this.form)) {
          this.form.coupon = this.$route.query.coupon ?? this.coupon ?? ''
          this.form.voucher = this.$route.query.voucher ?? this.voucher ?? ''

          if (sessionStorage.getItem(`generateBoleto:${this.form.plan}`)) {
            let info = JSON.parse(sessionStorage.getItem(`generateBoleto:${this.form.plan}`))
            this.$emit('showBoleto', info)
            this.loading = false
          } else
          api
            .post('v1/subscribe/storeCreateUser', this.form)
            .then(({ data }) => {
              if (data.process) {
                this.$emit('showBoleto', data.url)
                this.eventGTMPurchase(data.orderId)
                sessionStorage.setItem(
                    `generateBoleto:${this.form.plan}`,
                    JSON.stringify(data.url)
                  )
              } else this.error(data.errors)

              if (data.login) {
                this.setUser(data.login.user)
                this.setJwt(data.login.token)
              }
            })
            .catch(
              ({
                response: {
                  data: { errors }
                }
              }) => this.error(errors)
            )
            .finally(() => (this.loading = false))
        } else this.loading = false
      }
    }
  })
</script>

<style scoped lang="css">
  .container-pay {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    margin-bottom: 15px;
    background-color: #fff;
    font-size: small;
  }

  .form-control:focus {
    color: #000;
    background-color: #f8f8f8;
  }

  .legend {
    font-size: 12px;
    width: 100%;
    color: gray;
    text-align: center;
  }

  .d-w-btn {
    color: #fff;
    padding: 17px 30px;
    background: #52a734;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    min-width: 210px;
    align-items: center;
    font-family: 'Exo-2';
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
  }
</style>
